import * as React from 'react';
import '../../../styles/Toggle.css';

interface Props {
    checked: boolean;
    onChange: (value: boolean) => void;
    disabled?: boolean;
}

const Toggle = (props: Props) => {
    return (
        <label className="switch">
            <input
                type="checkbox"
                checked={props.checked}
                onChange={() => !props.disabled && props.onChange(!props.checked)}
                disabled={props.disabled}
            />
            <span className="slider round" />
        </label>
    );
};

export default Toggle;



// WEBPACK FOOTER //
// ./src/components/common/form/Toggle.tsx